import { UserInfo } from '../services/user/user.service'

/** SUPER_ADMIN を除く管理権限（ENABLER または isManager）を持つかどうかを判定する。 */
export const hasTrygroupManagementRole = (user: UserInfo): boolean =>
  user.isManager || user.roles.some((role) => role.code === 'ENABLER')
